module.exports = __webpack_public_path__ + "img/Location.8b30aa35.svg";